import React from 'react';
import { Check } from 'lucide-react';

const GET = [
  'Every PractCom feature unlocked, free, for 90 days',
  'Free for life if you send your testimonial, photo and a 5-star review',
  'No credit card asked for at any point',
  'Post-op instructions, consents, Med Cards, Dictate Visit, referrals, translations and Dr. G',
  'A founder — Dr. Cary Ganz — who answers your emails himself',
];
const ASK = [
  'Use PractCom with real patients in your own practice',
  'Within 7 days of the beta ending, an honest written testimonial — good or bad',
  'A clear photo of YOU with it — a real face, not a logo. This is a condition of the free account.',
  'Permission to publish it with your name, credentials, practice and town',
];

const List = ({ items, tone, testId }) => (
  <ul className="space-y-3" data-testid={testId}>
    {items.map((t) => (
      <li key={t} className="flex gap-3 text-[15px] leading-snug text-[#0E2340]">
        <Check className={`w-4 h-4 mt-0.5 shrink-0 ${tone}`} strokeWidth={3} />{t}
      </li>
    ))}
  </ul>
);

export const BetaHero = ({ info }) => (
  <section className="pt-10 sm:pt-16">
    <span className="inline-flex items-center gap-2 font-mono text-[13px] tracking-[.08em] uppercase text-[#0B5FA8] border border-[#D9E2EB] bg-white px-3.5 py-2 rounded-full" data-testid="beta-spots-badge">
      Beta program · {info?.spots ?? 10} practices{info && info.spotsLeft < info.spots ? ` · ${info.spotsLeft} spots left` : ''}
    </span>
    <h1 className="beta-display mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#0E2340] leading-[1.05]">
      Use all of PractCom free.<br /><span className="text-[#0A7A55]">Tell us the truth in return.</span>
    </h1>
    <p className="mt-6 text-lg sm:text-xl text-[#46586E] leading-relaxed max-w-2xl">
      We're giving {info?.spots ?? 10} dental practices full, free access to PractCom for 90 days. All we want back is an honest
      testimonial — with a photo of you — that we can publish. Even the parts that need work. Send it with a 5-star
      review and PractCom is free for your practice for life.
    </p>
    <div className="mt-10 grid sm:grid-cols-2 gap-4">
      <div className="bg-white border border-[#D9E2EB] rounded-2xl p-6">
        <p className="font-mono text-xs tracking-[.12em] uppercase text-[#0A7A55] mb-4">What you get</p>
        <List items={GET} tone="text-[#0A7A55]" testId="beta-what-you-get" />
      </div>
      <div className="bg-[#EAF3FC] border border-[#BFD9F2] rounded-2xl p-6">
        <p className="font-mono text-xs tracking-[.12em] uppercase text-[#0B5FA8] mb-4">What we ask</p>
        <List items={ASK} tone="text-[#0B5FA8]" testId="beta-what-we-ask" />
      </div>
    </div>
  </section>
);
